import React from 'react';
import { 
  BsPeopleFill, 
  BsFileEarmarkCheckFill, 
  BsStarFill, 
  BsRocketTakeoffFill 
} from 'react-icons/bs';
import { useCMS } from '../../context/CMSContext';

const Score = () => {
  const { getSection } = useCMS();
  const homeCMS = getSection('home', {
    statsClients: "100+",
    statsProjects: "250+",
    statsExperience: "5+",
    statsSatisfaction: "99%"
  });

  const statsData = [
    {
      icon: <BsPeopleFill className="text-2xl" />,
      value: homeCMS.statsClients || "100+",
      label: "Happy Clients"
    },
    {
      icon: <BsFileEarmarkCheckFill className="text-2xl" />,
      value: homeCMS.statsProjects || "250+",
      label: "Projects Delivered"
    },
    {
      icon: <BsStarFill className="text-2xl" />,
      value: homeCMS.statsExperience || "5+",
      label: "Years of Experience"
    },
    {
      icon: <BsRocketTakeoffFill className="text-2xl" />,
      value: homeCMS.statsSatisfaction || "99%",
      label: "Client Satisfaction"
    }
  ];

  return (
    <section className="bg-white text-slate-900 py-12 sm:py-16 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 text-center">
          {statsData.map((stat, idx) => (
            <div 
              key={idx} 
              className="flex flex-col items-center justify-center p-2 group"
              data-aos="fade-up"
              data-aos-delay={idx * 80}
            >
              <div className="w-12 h-12 rounded-2xl bg-orange-50 border border-orange-100 flex items-center justify-center mb-3 text-[#f06600] group-hover:scale-110 group-hover:bg-orange-100/90 group-hover:border-orange-300 transition-all duration-300">
                <span className="text-2xl text-[#f06600]">
                  {stat.icon}
                </span>
              </div>
              <div className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
                {stat.value}
              </div>
              <div className="text-xs sm:text-sm font-medium text-slate-500 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Score;